module.exports = __webpack_public_path__ + "static/media/bookIcon.d1fb44eb.png";